import { ActivityId, GAME_IDS } from '../../constants';
import { formatDate } from '../../util';

const chartOptions = {
  backgroundColor: 'rgba(91, 95, 245, 0.6)',
  borderColor: 'rgba(91, 95, 245, 1)',
  borderWidth: 1,
}

export const formatChartData = (statType: string, s: any) => {
  switch (statType) {
    case 'dailyMaxScore':
      return {
        labels: s?.map((item: any) => formatDate(item?.daysgroup, 'UTC', false)),
        datasets: [
          {
            ...chartOptions,
            label: 'Max Score',
            data: s?.map((item: any) => item?.maxScore),
          },
        ],
      };

      case 'dailyPlayTime':
      return {
        labels: s?.map((item: any) => formatDate(item?.daysgroup, 'UTC', false)),
        datasets: [
          {
            ...chartOptions,
            label: 'Time',
            data: s?.map((item: any) => item?.totalTime),
          },
        ],
      };

    case 'favoriteGame':
      return {
        labels: s?.map((item: { gameIdsgroup: ActivityId }) => GAME_IDS[item.gameIdsgroup]),
        datasets: [
          {
            ...chartOptions,
            label: 'Time',
            data: s?.map((item: any) => item?.totalTime),
          },
        ],
      };

    default:
      return { labels: [], datasets: [] };
  }
}